import React, { ReactNode, useEffect, useState } from 'react'

import { useIntersection } from 'shared/hooks'

type PropsType = {
  number: number
  duration: number
  className?: string
  children?: ReactNode
}

export const Count = (props: PropsType): JSX.Element => {
  const { number, duration } = props
  const [count, setCount] = useState(0)
  const [visibleCount, setVisibleCount] = useState(0)
  const [ref, entry] = useIntersection({})

  useEffect(() => {
    if (count !== number) {
      setCount(number)
    }

    let start = 0

    if (!entry?.isIntersecting || start === count) {
      return
    }

    const totalMilSecDur = duration
    const incrementTime = (totalMilSecDur / count) * 1000

    const timer = setInterval(() => {
      const startInc = start + 1
      start = startInc > number ? number : startInc
      setVisibleCount(start)
      if (start === count) {
        setVisibleCount(start)
        clearInterval(timer)
      }
    }, incrementTime)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [number, duration, entry, count])

  return (
    <span className={props?.className} ref={ref}>
      {visibleCount}
      {props.children}
    </span>
  )
}
